import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import postscribe from 'postscribe';

@Component({
  selector: 'app-wizaz-reviews',
  templateUrl: './wizaz-reviews.component.html',
  styleUrls: ['./wizaz-reviews.component.scss']
})
export class WizazReviewsComponent implements OnInit, AfterViewInit {

  @Input() id;

  elementId = Math.random().toString(36).substring(7);

  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit() {
      postscribe(`#reviews_${this.elementId}`, `<script async data-id="54cefd6886b2262f0d2f499e0d2d64a3" data-params-id="${this.id}"src="https://c2c.edipresse.pl/script/init.js" ></script>`);
  }

}
